import { useState } from "react";
import { useNavigate } from "react-router-dom";

/** DrawIt landing — choose to host (big screen) or join (controller). */
export function DrawEntry() {
  const nav = useNavigate();
  const [joining, setJoining] = useState(false);
  const [code, setCode] = useState("");

  const submitJoin = (e: React.FormEvent) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (c.length >= 3) nav(`/drawit/play?code=${c}`);
  };

  return (
    <div className="quizzle-entry">
      <h1 className="quizzle-entry-title">🎨 DrawIt</h1>
      <p className="quizzle-entry-sub">Class drawing game — host on the big screen, everyone guesses on their iPads.</p>
      {!joining ? (
        <div className="quizzle-entry-actions">
          <button className="btn btn-green btn-big btn-block" onClick={() => nav("/drawit/host")}>🖥️ Host on this screen</button>
          <button className="btn btn-blue btn-big btn-block" onClick={() => setJoining(true)}>📱 Join a game</button>
          <button className="btn btn-ghost" onClick={() => nav("/")}>← Menu</button>
        </div>
      ) : (
        <form className="quizzle-entry-actions" onSubmit={submitJoin}>
          <input
            className="quizzle-code-input"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
            placeholder="CODE"
            maxLength={6}
            autoFocus
            inputMode="text"
            aria-label="Room code"
          />
          <button className="btn btn-green btn-big btn-block" type="submit" disabled={code.trim().length < 3}>Join</button>
          <button className="btn btn-ghost" type="button" onClick={() => setJoining(false)}>← Back</button>
        </form>
      )}
    </div>
  );
}
